import { fetch } from '@/core/utils/drf/fetch'

// After getting a token, this function
// gets any extra info needed for the current user
export const fetchUserInfo = async ({
  token,
  isPurposelyAdmin,
  isCompanyAdmin,
  isNonprofitAccount,
  ...rest
}) => {
  const info = {}
  info.profile = await fetch('me', { token })
  if (info.profile.isNonprofitAccount) {
    if (info.profile.nonprofitJoinIsPending) {
      info.nonprofit = null
      info.homeUrlName = 'nonprofitPendingApproval'
      info.nextUrl = 'nonprofitPendingApproval'
    } else {
      try {
        info.nonprofit = await fetch('myNonprofit', { token })
        const missingDocs = !info.nonprofit.hasBankingDetailsFile || !info.nonprofit.hasAuthorizationFormFile || !info.nonprofit.hasDeterminationLetterFile
        if (info.nonprofit.status !== 'approved' && missingDocs) {
          info.homeUrlName = 'nonprofitOnboarding'
          info.nextUrl = 'nonprofitOnboarding'
        } else if (info.nonprofit.status !== 'approved') {
          info.nextUrl = 'nonprofitPendingApproval'
        } else if (!info.profile.firstName) {
          info.homeUrlName = 'nonprofitOnboarding'
          info.nextUrl = 'nonprofitOnboarding'
        } else {
          info.homeUrlName = 'nonprofitDashboard'
        }
      } catch (err) {
        if (err.technical?.result?.status === 404 || err.fieldErrors?.detail === 'Not found.') {
          info.nonprofit = null
          info.homeUrlName = 'nonprofitOnboarding'
          info.nextUrl = 'nonprofitOnboarding'
        } else {
          throw err
        }
      }
    }
  } else {
    info.employeeProfile = await fetch('employeeProfile', { token })
  }
  if (!info.profile.isPurposelyAdmin) {
    if (info.nonprofit) {
      if (!info.nonprofit.completedOnboarding && info.profile.firstName) {
        info.legacyNextUrl = 'nonprofit/onboarding2'
      }
    } else if (info.profile.isNonprofitAccount) {
      info.homeUrlName = 'nonprofitOnboarding'
      info.nextUrl = 'nonprofitOnboarding'
    } else {
      info.homeUrlName = 'companyActivity'
      if (!info.employeeProfile.completedOnboarding) {
        info.nextUrl = 'onboardingGeneralInfo'
      }
    }
  } else {
    info.homeUrlName = 'adminMetrics'
  }

  return info
}
